import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef2d3a4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ef2d3a4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2d3a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef2d3a4c')) {
      api.createRecord('ef2d3a4c', component.options)
    } else {
      api.reload('ef2d3a4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef2d3a4c&scoped=true", function () {
      api.rerender('ef2d3a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/manage-lesson/index.vue"
export default component.exports